import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { ExamType } from "./type";

export const examTypeLoader: LoaderFunction = async (args) => {
  if (args.params.assignmentPeriodCode === "new") {
    return new Promise((res) => res(Result.newResult()));
  }
  const result = await axiosApi.get<Result<ExamType>>(
    "/api/examTypes/" + args.params.code
  );
  return result.data;
};
